import { createContext } from 'react'

import type { Role } from 'types/hub-role'

/**
 * Owner-only, render-only "view as" preview state. Holds the previewed hub
 * role an owner has selected (or `null` when not previewing). Persisted in
 * `sessionStorage` so it survives a reload within the tab session, and cleared
 * on hub switch and on sign-out. Never changes what the backend authorizes.
 */
export interface ViewAsRoleValue {
  readonly previewedHubRole: Role | null
  readonly setPreviewedHubRole: (role: Role) => void
  readonly clearPreview: () => void
}

export const ViewAsRoleContext = createContext<ViewAsRoleValue | null>(null)
